import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAccountDetails = createAsyncThunk(
    'account/fetchAccountDetails',
    async (_, { rejectWithValue }) => {
        try  {
            const response = await axios.get('/meonsupport/account_detail', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
);

const accountSlice = createSlice({
    name: 'account',
    initialState: {
        data: {},
        contact_email: '',
        contact_person: '',
        contact_number: '',
        customer_name: '',
        customer_id: '',
        products: '',
        session_response: '',
        session_flag: false,
        status: 'idle',
        error: null
    },

    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchAccountDetails.pending, (state) => {
            state.status = 'loading';
        })
        .addCase(fetchAccountDetails.fulfilled, (state, action) => {
            state.status = 'succeeded';
            const data = action.payload;
            if (data.msg === 'Logged Out') {
                state.session_response = 'Session expired. Please login again.';
                state.session_flag = true;
            } else {
                state.data = data;
                state.customer_name = data.customer_name;
                state.contact_email = data.email;
                state.products = data.products;
                state.contact_number = data.contact_number;
                state.customer_id = data.customer_id;
                state.contact_person = data.contact_person;
            }
        })
        .addCase(fetchAccountDetails.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload || action.error.message;
        });
    }
});

export default accountSlice.reducer;